module.exports = __webpack_public_path__ + "img/gatorz-compare-image.1e58f39a.png";